<div *ngIf="isOpen" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
  <div
    class="relative w-full max-w-lg bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 flex flex-col max-h-[90vh] overflow-hidden animate-fade-in-up"
    (click)="$event.stopPropagation()">

    <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-800">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-xl bg-rose-50 dark:bg-rose-500/10 text-rose-500 flex items-center justify-center">
          <span class="material-icons">logout</span>
        </div>
        <div>
          <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">ทำรายการออก</h3>
          <p class="text-xs text-slate-400">Force Exit Transaction</p>
        </div>
      </div>
      <button type="button" (click)="close()" [disabled]="isSubmitting"
        class="w-8 h-8 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="p-6 space-y-4 overflow-y-auto custom-scrollbar" (click)="closeDropdowns()">
      <div class="rounded-2xl border border-slate-100 dark:border-slate-800 bg-slate-50 dark:bg-slate-800/50 p-4 space-y-2">
        <div class="flex justify-between gap-3 text-sm">
          <span class="text-slate-400 font-medium">ทะเบียน</span>
          <span class="font-black text-slate-800 dark:text-slate-100">{{ transaction?.entryLicense || '-' }}</span>
        </div>
        <div class="flex justify-between gap-3 text-sm">
          <span class="text-slate-400 font-medium">บัตร / Card Code</span>
          <span class="font-mono font-bold text-slate-700 dark:text-slate-200 text-right break-all">{{ transaction?.cardCode || '-' }}</span>
        </div>
        <div class="flex justify-between gap-3 text-sm">
          <span class="text-slate-400 font-medium">สถานที่</span>
          <span class="font-bold text-slate-700 dark:text-slate-200 text-right">{{ transaction?.siteName || '-' }}</span>
        </div>
      </div>

      <label class="flex items-start gap-3 p-3 rounded-xl border cursor-pointer select-none transition-colors"
        [ngClass]="localOnly
          ? 'border-rose-200 bg-rose-50 dark:border-rose-500/30 dark:bg-rose-500/10'
          : 'border-slate-100 bg-slate-50 dark:border-slate-700 dark:bg-slate-800'">
        <input type="checkbox" [(ngModel)]="localOnly"
          class="mt-0.5 w-4 h-4 rounded border-slate-300 text-rose-500 focus:ring-rose-400"
          [disabled]="isSubmitting" />
        <span class="flex flex-col">
          <span class="text-sm font-bold" [ngClass]="localOnly ? 'text-rose-600 dark:text-rose-400' : 'text-slate-600 dark:text-slate-300'">
            ปิดเฉพาะใน DB (ไม่ส่ง Taiwan)
          </span>
          <span class="text-[11px] text-slate-400">ใช้เมื่อ Taiwan ปิดรายการแล้วแต่ไม่ได้แจ้งกลับมา — ไม่เปิดไม้กั้น</span>
        </span>
      </label>

      <div class="relative" *ngIf="!localOnly">
        <label class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2 block">
          ประตูออก <span class="text-rose-500">*</span>
        </label>
        <div class="relative h-[46px] flex items-center rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800">
          <span class="material-icons text-slate-400 absolute left-3 text-lg">door_front</span>
          <input type="text" [(ngModel)]="gateSearchText"
            (focus)="isGateDropdownOpen = true; $event.stopPropagation()"
            (click)="$event.stopPropagation()"
            (blur)="closeDropdowns()"
            placeholder="พิมพ์ค้นหาประตูออก..."
            class="w-full h-full pl-11 pr-10 bg-transparent rounded-xl text-sm font-bold text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-amber-200"
            [disabled]="isSubmitting" />
          <span class="material-icons text-slate-400 absolute right-3 text-sm pointer-events-none"
            [class.rotate-180]="isGateDropdownOpen">expand_more</span>
        </div>
        <div *ngIf="isGateDropdownOpen" (mousedown)="$event.preventDefault()"
          class="absolute z-40 left-0 right-0 mt-1 max-h-48 overflow-y-auto custom-scrollbar bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1">
          <div *ngIf="filteredGates.length === 0" class="px-3 py-2 text-xs text-slate-400 text-center font-bold">ไม่พบประตู</div>
          <button type="button" *ngFor="let g of filteredGates" (click)="selectGate(g)"
            class="w-full text-left px-3 py-2 text-sm font-bold text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600">
            {{ g.name }}
          </button>
        </div>
      </div>

      <div>
        <label class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2 block">
          เหตุผล <span class="text-rose-500">*</span>
        </label>
        <textarea [(ngModel)]="reason" rows="3" placeholder="ระบุเหตุผลทำรายการออก..."
          class="w-full px-4 py-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-amber-200 resize-none"
          [disabled]="isSubmitting"></textarea>
      </div>

      <label class="flex items-center gap-2 cursor-pointer select-none" *ngIf="!localOnly">
        <input type="checkbox" [(ngModel)]="openGate"
          class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400"
          [disabled]="isSubmitting" />
        <span class="text-sm font-bold text-slate-600 dark:text-slate-300">เปิดไม้กั้น (Open Gate)</span>
      </label>
    </div>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-end gap-3 bg-slate-50/80 dark:bg-slate-900/50">
      <button type="button" (click)="close()"
        class="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-sm text-slate-600 dark:text-slate-300 disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="isSubmitting">ยกเลิก</button>
      <button type="button" (click)="askSubmit()"
        class="px-6 py-2.5 rounded-xl bg-rose-500 hover:bg-rose-600 text-white font-bold text-sm disabled:opacity-50 flex items-center gap-2 disabled:cursor-not-allowed"
        [disabled]="isSubmitting">
        ยืนยันทำรายการออก
      </button>
    </div>
  </div>
</div>

<app-pss-confirm-modal *ngIf="showConfirm"
  title="ยืนยันทำรายการออก?"
  [message]="confirmMessage"
  confirmLabel="ใช่, ทำรายการ"
  cancelLabel="ไม่"
  variant="warning"
  icon="logout"
  [showIrreversibleNote]="false"
  [loading]="isSubmitting"
  (confirm)="confirmSubmit()"
  (cancel)="closeConfirm()">
</app-pss-confirm-modal>

<app-pss-loading *ngIf="isSubmitting"></app-pss-loading>
